export const AUTH_STATE_REQUESTED = 'authStateRequested';
export const AUTH_STATE_STARTED_LISTENING = 'authStateStartedListening';
